import "./wizard.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import * as React from "react";

import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

export default function EnrollmentFailed(): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "AiGuideTeacherFeaturesEnrollFailedPageViewed",
            eventSchemaVersion: 1,
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`We were unable to activate Khanmigo for you.`}
                </h1>
                <p>
                    <Trans>
                        An unexpected error occurred during activation. This
                        could be caused by a temporary problem. Trying again in
                        a few minutes may resolve it. If the issue continues
                        please{" "}
                        <Link
                            href="https://support.khanacademy.org/"
                            target="_blank"
                        >
                            contact our support team
                        </Link>
                        .
                    </Trans>
                </p>
            </div>
        </div>
    );
}
